<template>
  <div v-if="loading" class="full-loader">
      <div class="layout">
        <div class="loader">
            <div class="quad-1 quad"></div>
            <div class="quad-2 quad"></div>
            <div class="quad-3 quad"></div>
            <div class="quad-4 quad"></div>
        </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'FullLoader',
  props: ["loading"]
}
</script>

<style scoped>
</style>







// WEBPACK FOOTER //
// src/components/FullLoader.vue